// WHERE A TASK IS WORKED — the one place a board name becomes a route.
//
// `calculations/dueTasks` decides which list a dated task belongs to and says so in its
// own vocabulary ('customers' / 'leads' / 'none'). The server deliberately knows no URLs,
// so something in the browser has to make that translation — and now two screens ask for
// it: the notification bell and היום שלי, which read the very same rows from the very same
// payload. Two copies of the mapping is how one of them goes on pointing at a route after
// it moves, which is exactly what happened to the board: it lived at '/' until היום שלי
// became the landing page, and '/' was written into the bell.
//
// 'none' IS NOT A BOARD AND NEVER GETS ONE. A task on a lost lead or a deactivated client
// is on neither list — the work board takes active customers, the pipeline takes live
// leads — so the only screen that still holds it is the client's own card. That is the
// orphan case both callers mark on the row, and the reason the fallback is a client link
// rather than a board.
//
// The words come from `he.alerts` rather than being duplicated per screen: this is one
// act ("go to where this is worked") phrased once, and the label has to agree with the
// path it is printed beside.
import he from '../i18n/he';

export const boardLink = (row) => {
  if (row.board === 'customers') return '/board';
  if (row.board === 'leads') return '/leads';
  return `/clients/${row.client.id}`;
};

export const boardLinkLabel = (row) => {
  if (row.board === 'customers') return he.alerts.goBoard;
  if (row.board === 'leads') return he.alerts.goLeads;
  return he.alerts.goClient;
};
